import React from "react";
import { string, bool, object } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../Headline";

import "./collection-title-with-arrow.m.css";

const CollectionTitleWithArrow = ({
  collectionSlug,
  collectionName,
  headlineClassName = "",
  updatedFont = false,
  publisherAttributes
}) => {
  const headlineStyle = updatedFont ? `${publisherAttributes.lang}-collection-title` : "";
  return (
    <Link href={collectionSlug}>
      <Headline
        text={collectionName}
        headerLevel={2}
        headlineDesign="witharrow"
        className={headlineClassName}
        styleName={headlineStyle}
      />
    </Link>
  );
};

CollectionTitleWithArrow.propTypes = {
  collectionName: string,
  collectionSlug: string,
  headlineClassName: string,
  updatedFont: bool,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(CollectionTitleWithArrow);
